import { CONNECTOR_AUTH_FORBIDDEN_HEADERS, CONNECTOR_AUTH_LIMITS, CONNECTOR_FORBIDDEN_HEADER_PREFIX, CONNECTOR_HEADER_NAME_PATTERN, CONNECTOR_ENDPOINT_MODE } from "@sagot/constants";

/** The connector authentication of an endpoint (a header the Data connector sends with every request): the checks the form makes before the server does. */

export type AuthHeaderProblem = "empty" | "invalid" | "forbidden";
export type AuthValueProblem = "empty" | "long" | "control";

const CONTROL_BELOW = 0x20;
const DELETE_CHAR = 0x7f;

/** Credential headers are fine here (that is what this is for); the transport headers and Sagot's own are not. */
export function authHeaderProblem(name: string): AuthHeaderProblem | null {
  const trimmed = name.trim();
  if (trimmed === "") return "empty";
  if (!CONNECTOR_HEADER_NAME_PATTERN.test(trimmed)) return "invalid";
  const lower = trimmed.toLowerCase();
  return CONNECTOR_AUTH_FORBIDDEN_HEADERS.has(lower) || lower.startsWith(CONNECTOR_FORBIDDEN_HEADER_PREFIX) ? "forbidden" : null;
}

export function authValueProblem(value: string): AuthValueProblem | null {
  const trimmed = value.trim();
  if (trimmed === "") return "empty";
  if (trimmed.length > CONNECTOR_AUTH_LIMITS.value) return "long";
  return Array.from(trimmed).some((char) => char.charCodeAt(0) < CONTROL_BELOW || char.charCodeAt(0) === DELETE_CHAR) ? "control" : null;
}

/** What is sent to save the authentication: the header name and the secret, both trimmed. */
export const authBodyOf = (header: string, value: string): { header: string; value: string } => ({ header: header.trim(), value: value.trim() });

/** Only an endpoint that workflows call has connector authentication. */
export const supportsConnectorAuth = (deliveryMode: string): boolean => deliveryMode === CONNECTOR_ENDPOINT_MODE;
